import * as React from 'react';

import { HeroBentoModule } from '@coursera-web/cds-labs';

import { useCampaignModulesData } from 'bundles/campaigns/context/CampaignModulesDataContext';

type Props = {
  showOptimization?: boolean;
};

const HeroBentoModuleRenderer = ({ showOptimization = false }: Props) => {
  const moduleData = useCampaignModulesData()?.campaignData?.heroModule;

  const content = moduleData?.contentDataJson || {};

  const cards = content?.cardsCollection?.items ?? [];
  const filteredCards = cards.filter(Boolean) as Array<NonNullable<typeof cards>[number]>;

  const itemCards =
    filteredCards.map((item, index) => {
      return {
        id: item.sys.id,
        index,
        ...item,
        eyebrow: {
          image: item.eyebrowImage,
          eyebrowImageHeight: item.eyebrowImageHeight,
        },
        cta: {
          target: item.ctaTarget,
          label: item.ctaText,
        },
        desktopImage: {
          ...item.image,
        },
        mobileImage: {
          ...(item.mobileImage ? item.mobileImage : item.image),
        },
        campaignEventingData: {
          id: moduleData?.campaignId ?? '',
          matchedCountryCode: moduleData?.matchedCountryCode ?? '',
          epicExperimentId: moduleData?.epicExperimentId ?? '',
          regionName: moduleData?.regionName ?? '',
          name: moduleData?.campaignName ?? '',
        },
      };
    }) ?? [];

  return <HeroBentoModule cards={itemCards} showOptimization={showOptimization} />;
};

export default HeroBentoModuleRenderer;
